import { Timeout } from 'src/app/shared/helpers/Timeout';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProgressBarComponent } from '../../components/progress-bar/progress-bar.component';
import { ErrorRouter } from '../../services/error-router';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatIconModule } from '@angular/material/icon';

/**
 * Important: 
 * These field names must match 1:1 with the ErrorComponent's input names
 */
export interface ErrorPageQueryParameters {
  headerText: string;
  subText: string;
  materialIconName: string;
  materialIconColorClass: string;
  onClickButtonName: string;
  onClickNavigationRoute?: string;
  replaceUrl?: boolean
}

/**
 * Important:
 * Inputs are injected from query parameters, the names must match 1:1 in the query parameters list.
 * 
 * Use the ErrorPageQueryParameters interface to pass into the router.navigate function.
 * 
 * When 'onClickNavigationRoute' is left as undefined the on click action will reload the
 * page rather than redirecting to another route.
 */
@Component({
    selector: 'app-error-component',
    templateUrl: './error-page.component.html',
    standalone: true,
    imports: 
    [
      CommonModule,
      FlexModule, 

      MatCardModule, 
      MatIconModule,
      MatButtonModule, 

      ProgressBarComponent,
    ]
})
export class ErrorComponent implements OnInit {

  @Input({required: true}) headerText: string;
  @Input({required: true}) subText: string;
  @Input({required: true}) materialIconName: string;
  @Input({required: true}) materialIconColorClass: string;
  @Input({required: true}) onClickButtonName: string;

  @Input() onClickNavigationRoute: string;
  @Input() replaceUrl: boolean = false;

  get iconClass(): string {
    return `material-icons ${this.materialIconColorClass} icon-display-large`;
  };

  @ViewChild(ProgressBarComponent, {static: true}) progressBar: ProgressBarComponent;
  constructor(
    private router: Router, 
    private errorRouter: ErrorRouter
  ) { }

  ngOnInit() {
    if(this.headerText === undefined || this.onClickButtonName === undefined) {
      this.errorRouter.navigateToNotFound();
    }
  }

  action() {
    if(this.onClickNavigationRoute === undefined) {
      this.reload();
      return;
    }

    this.progressBar.show();
    
    // Delay is required to compensate for any resolver request(s) to timeout first
    Timeout.delayActionShort(() => {
      this.router.navigate([this.onClickNavigationRoute], { replaceUrl: this.replaceUrl });
      this.progressBar.hide();
    });
  }

  private reload() {
    window.location.reload();
  }
}
